import ui.App

fun main() {
    App().mount()
}
